/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinGameAssets} from "../HarlequinGameAssets";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {Harlequin} from "../Harlequin";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class HarlequinIntroConfig implements GameIntroViewConfig {

    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000,
            backgroundAlpha: 0.6,
            bulletColor: 0xffffff
        },
        stampColor: 0xFFFFFF,
    };


    stampConfig: StampConfig = {
        xWays: false,
        xNudge: true,
        volatility: Volatility.HIGH
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];

    constructor() {
    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add(HarlequinGameAssets.NEW_INTRO_BACKGROUND_PLATE, HarlequinGameAssets.NEW_INTRO_BACKGROUND_PLATE);
        imgLoader.add(HarlequinGameAssets.INTRO_BORDER_TILE, HarlequinGameAssets.INTRO_BORDER_TILE);
        imgLoader.add(HarlequinGameAssets.INTRO_FEATURE_1, HarlequinGameAssets.INTRO_FEATURE_1);
        imgLoader.add(HarlequinGameAssets.INTRO_FEATURE_1_US, HarlequinGameAssets.INTRO_FEATURE_1_US);
        imgLoader.add(HarlequinGameAssets.INTRO_FEATURE_2, HarlequinGameAssets.INTRO_FEATURE_2);
        imgLoader.add(HarlequinGameAssets.INTRO_FEATURE_3, HarlequinGameAssets.INTRO_FEATURE_3);
        imgLoader.add(HarlequinGameAssets.INTRO_FEATURE_3_US, HarlequinGameAssets.INTRO_FEATURE_3_US);
        imgLoader.add(HarlequinGameAssets.INTRO_WOMAN, HarlequinGameAssets.INTRO_WOMAN);


        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgBlack = new PIXI.Sprite(PIXI.Texture.WHITE);
        bgBlack.anchor.set(0.5, 0.5);
        bgBlack.tint = 0x000000;
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture(HarlequinGameAssets.NEW_INTRO_BACKGROUND_PLATE));
        bgSprite.anchor.set(0.5, 0.5);


        this.background.addChild(bgBlack);
        this.background.addChild(bgSprite);


        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.TilingSprite(ImgLoader.getImgTexture(HarlequinGameAssets.INTRO_BORDER_TILE), 1680, 77);
        topSprite.anchor.set(0.5, 0.2);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.TilingSprite(ImgLoader.getImgTexture(HarlequinGameAssets.INTRO_BORDER_TILE), 1680, 77);
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.2);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const woman = new PIXI.Sprite(ImgLoader.getImgTexture(HarlequinGameAssets.INTRO_WOMAN));
        woman.anchor.set(0.5, 0.40);
        woman.scale.set(1.4, 1.4);
        this.logo.addChild(woman);

        this.pages = [];
        if (Harlequin.api.gameClientConfiguration.isSet) {
            this.loadPages();
        } else {
            Harlequin.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                this.loadPages();
            });
        }


        NolimitApplication.events.on(NolimitApplication.RESIZE, () => {
            const bounds = NolimitApplication.screenBounds;
            bgSprite.width = bounds.width;
            bgSprite.height = bounds.height;
            bgBlack.width = bounds.width;
            bgBlack.height = bounds.height;
        });

    }
    private loadPages(): void {
        const featureText1 = /*"HARLEQUIN xNUDGE WILDS\n\n" + */SlotGame.api.translations.translate("Harlequin xNudge Wilds will always nudge and increase the multiplier!");
        const featureText2 = /*"HARLEQUIN RESPIN\n\n" + */ SlotGame.api.translations.translate("The xNudge Wild will walk one step to the left on the reel and award a respin.");
        const featureText3 = /*"HARLEQUIN BONUS\n\n" + */ SlotGame.api.translations.translate("Collect 3 Bonus symbols award 8 Harlequin Bonus spins, where xNudge Wilds may be multiplied up to x7!");
        const featureText3_US: string = SlotGame.api.translations.translate("Collect 3 Bonus symbols award 8 Harlequin Bonus spins.");

        if (!Harlequin.api.gameClientConfiguration.showMultipliersInfo) {
            this.pages = [
                new SlideShowPage(ImgLoader.getImgTexture(HarlequinGameAssets.INTRO_FEATURE_1_US), featureText1),
                new SlideShowPage(ImgLoader.getImgTexture(HarlequinGameAssets.INTRO_FEATURE_2), featureText2),
                new SlideShowPage(ImgLoader.getImgTexture(HarlequinGameAssets.INTRO_FEATURE_3_US), featureText3_US)
            ];
        } else {
            this.pages = [
                new SlideShowPage(ImgLoader.getImgTexture(HarlequinGameAssets.INTRO_FEATURE_1), featureText1),
                new SlideShowPage(ImgLoader.getImgTexture(HarlequinGameAssets.INTRO_FEATURE_2), featureText2),
                new SlideShowPage(ImgLoader.getImgTexture(HarlequinGameAssets.INTRO_FEATURE_3), featureText3)
            ];
        }
    }
}